
import axios from 'axios'

import BaseService from './BaseService'
const Environment = require('../environments/environment.json')

const getBase64Document = (docRequest, sessionKey) =>
{
    return new Promise((resolve, reject) =>
    {
        BaseService
            .requestHeaders(sessionKey)
            .then((headers) =>
            {
                resolve( axios.post(`${Environment.apiUrl}/Documents/GetBase64Document`, docRequest, headers) )
            })
            .catch((error) =>
            {
                reject(error)
            })
    })
}

const getPdfDocumentStream = (docRequest, sessionKey) =>
{
    return new Promise((resolve, reject) =>
    {
        BaseService
            .requestHeaders(sessionKey)
            .then((headers) =>
            {
                resolve( axios.post(`${Environment.apiUrl}/Documents/GetPdfDocumentStream`, docRequest, headers) )
            })
            .catch((error) =>
            {
                reject(error)
            })
    })
}

const DocumentsService =
{
    getBase64Document,
    getPdfDocumentStream
}

export default DocumentsService
